/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LogAction } from '../models/log-action';
import { logActionControllerAdd } from '../fn/log-action/log-action-controller-add';
import { LogActionControllerAdd$Params } from '../fn/log-action/log-action-controller-add';
import { logActionControllerRetrieveLogActions } from '../fn/log-action/log-action-controller-retrieve-log-actions';
import { LogActionControllerRetrieveLogActions$Params } from '../fn/log-action/log-action-controller-retrieve-log-actions';

@Injectable({ providedIn: 'root' })
export class LogActionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `logActionControllerAdd()` */
  static readonly LogActionControllerAddPath = '/log-action';

  /**
   * Add new log action.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logActionControllerAdd()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  logActionControllerAdd$Response(params: LogActionControllerAdd$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = logActionControllerAdd(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add new log action.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logActionControllerAdd$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  logActionControllerAdd(params: LogActionControllerAdd$Params, context?: HttpContext): Observable<string> {
    const resp = this.logActionControllerAdd$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `logActionControllerRetrieveLogActions()` */
  static readonly LogActionControllerRetrieveLogActionsPath = '/log-action/query';

  /**
   * Query for log actions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logActionControllerRetrieveLogActions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  logActionControllerRetrieveLogActions$Response(params: LogActionControllerRetrieveLogActions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LogAction>>> {
    const obs = logActionControllerRetrieveLogActions(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Query for log actions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logActionControllerRetrieveLogActions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  logActionControllerRetrieveLogActions(params: LogActionControllerRetrieveLogActions$Params, context?: HttpContext): Observable<Array<LogAction>> {
    const resp = this.logActionControllerRetrieveLogActions$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<LogAction>>): Array<LogAction> => r.body)
    );
  }

}
